import styled from 'styled-components';

import {
  primaryColorStrong,
  primaryColorWeak,
  subMenuComponentBackground
} from '../../config/colors';

export const PrintWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
`;
export const IdCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  border-bottom: 1px darkGray solid;
  border-right: 0px;
  border-left: 0px;
  border-top: 0.5px darkGray solid;
  padding-bottom: 60px;
`;

export const PreparingForPrintingTitle = styled.h1`
  color: red;
  align-self: center;
  margin-bottom: 30px;
`;

export const Header = styled.div`
  display: flex;
  width: 100%;
  height: 90px;
  padding-right: 10px;
  margin-bottom: 20px;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  background-color: #D4D4D4;
  position: relative;
`;

export const IdCardText = styled.h2`
  height: 100%;
  margin: 0;
  font-weight: 600;
  margin-left: 20px;
`;


export const Ribbon = styled.div`
  width: 13px;
  height: 100%;
  background-color: ${primaryColorStrong};
  position: absolute;
`;

export const ModuleHeader = styled.div`
  height: 25px;
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
`;

export const ModuleTitle = styled.p`
  padding: 10px 15px 10px 23px;
  font-weight: 600;
  font-size: 1rem;
  color: ${primaryColorStrong};
`;

export const Project = styled.h1`
  height: 100%;
  display: flex;
  margin: 0;
  margin: auto 0;
  font-weight: 600;
  align-items: center;
`;

export const FastForwardLogo = styled.img`
  height: 80%;
  width: 100px;
`;

export const ModuleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TextualAndImageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  padding: 0 10px;
  justify-content: space-between;
`;

export const ViewsAndLayoutImageAndTitleWrapper = styled.div`
  width: 37%;
  height: 325px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ViewsAndLayoutImage = styled.img`
  width: 100%;
  height: 290px;
`;

export const ViewsAndLayoutImageTitle = styled.h3`
  font-weight: 600;
  margin-top: 5px;

  @media print {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    word-break: break-word;
    -webkit-box-orient: vertical;
  }
`;

export const VisualDetailsWrapper = styled.div`
  min-height: 520px;
  max-height: 520px;
  flex: 1;
  flex-direction: column;
`;

export const SubMenusWrapper = styled.ul`
  flex: 1;
  flex-direction: column;
  padding-left: 50px;
  padding-right: 85px;
  margin-top: 20px;
  float: none;

  @media print {
    page-break-before: always;
    padding: 0;
  }
  
`;

export const PageBreaker = styled.div`
  @media print {
    page-break-after: always;
  }
`;

export const MetricsWrapper = styled.div`
  height: 100px;
  width: 100%;
  margin-top: 40px;
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: space-between;
`;

export const DimensionsWrapper = styled.div`
  display: flex;
  width: 58%;
  flex-direction: row;

   table {
    width: 100%;
    text-align: center;
    border-spacing: 0;
    border-collapse: collapse;
    table-layout: fixed;

    .big-header {
      width: 100%;
      text-align: center;
      background-color: ${primaryColorWeak};
    }
    .small-header {
      width: 33%;
      background-color: ${subMenuComponentBackground};
      border: 1px solid ${primaryColorStrong};
      :first-of-type {
        border-left: 0;
      }
      :last-of-type {
        border-right: 0;
      }
    }

    td {
      border: 1px solid ${primaryColorStrong};
      border-bottom: 0;
      :first-of-type {
        border-left: 0;
      }
      :last-of-type {
        border-right: 0;
      }
    }
  }
`;

export const DimensionsImage = styled.img`
  height: 75px;
  margin-right: 5px;
`;

export const WeightsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 38%;

  table {
    width: 100%;
    text-align: center;
    border-spacing: 0;
    border-collapse: collapse;
    table-layout: fixed;

    .big-header {
      background-color: ${primaryColorWeak};
      border-bottom: 1px solid ${primaryColorStrong};
    }
    .small-header {
      background-color: ${subMenuComponentBackground};
      border-bottom: 1px solid ${primaryColorStrong};
    }
  }
`;

export const WeightsImage = styled.img`
  height: 75px;
  margin-right: 5px;
`;

